import * as THREE from "three";
import { TRACKPAD_WHEEL_DELTA_MAX_PX, TRACKPAD_WHEEL_SESSION_MS } from "./sceneConstants";

export function isLikelyTrackpadPanWheel(event, lastTrackpadWheelAt) {
  if (!event || event.ctrlKey || event.metaKey) return false;
  if (event.deltaMode !== 0) return false;

  const now = performance.now();
  if (now - lastTrackpadWheelAt < TRACKPAD_WHEEL_SESSION_MS) return true;

  const absX = Math.abs(event.deltaX || 0);
  const absY = Math.abs(event.deltaY || 0);
  if (absX > 0) return true;

  return (
    absY > 0 &&
    absY < TRACKPAD_WHEEL_DELTA_MAX_PX &&
    (!Number.isInteger(event.deltaY) || absY % 1 !== 0 || absY < 50)
  );
}

export function panCameraFromViewportDelta(camera, controls, domElement, deltaX, deltaY) {
  if (!camera || !controls || !domElement) return;
  const height = Math.max(1, domElement.clientHeight || domElement.getBoundingClientRect().height);
  const offset = new THREE.Vector3().subVectors(camera.position, controls.target);
  const targetDistance = offset.length() * Math.tan((camera.fov * Math.PI) / 360);
  const panX = (2 * deltaX * targetDistance) / height;
  const panY = (2 * deltaY * targetDistance) / height;
  const panOffset = new THREE.Vector3();
  const panVector = new THREE.Vector3();

  panVector.setFromMatrixColumn(camera.matrix, 0);
  panVector.multiplyScalar(-panX);
  panOffset.add(panVector);

  panVector.setFromMatrixColumn(camera.matrix, 1);
  panVector.multiplyScalar(panY);
  panOffset.add(panVector);

  camera.position.add(panOffset);
  controls.target.add(panOffset);
  controls.update();
}

export function getClientPointFromEvent(eventLike) {
  if (!eventLike) return null;
  const source = eventLike.nativeEvent || eventLike;
  if (Number.isFinite(source.clientX) && Number.isFinite(source.clientY)) {
    return { x: source.clientX, y: source.clientY };
  }
  const firstTouch = source.touches?.[0] || source.changedTouches?.[0];
  if (firstTouch && Number.isFinite(firstTouch.clientX) && Number.isFinite(firstTouch.clientY)) {
    return { x: firstTouch.clientX, y: firstTouch.clientY };
  }
  return null;
}
